/* eslint-disable hum/restrict-constants-imports */
import { incomeStatementAccountsByCategory } from "./incomeStatementAccounts";
import { balanceSheetAccountsByCategory } from "./balanceSheetAccounts";
import { LabelListStatementType } from "../Labeling.types";

export const labelsByStatementType = {
    [LabelListStatementType.BALANCE_SHEET]: balanceSheetAccountsByCategory,
    [LabelListStatementType.INCOME_STATEMENT]:
        incomeStatementAccountsByCategory,
};
